<template>
  <div class="background">
    <div v-if="showSpinner" class="spinner-container">
      <spinner-el />
    </div>
    <payments-table v-show="!showSpinner" @load="showSpinner = false" />
  </div>
</template>

<script>
  import paymentsTable from 'Common/PaymentsTable';

  export default {
    data: () => ({
      showSpinner: true,
    }),
    components: {
      paymentsTable,
    },
  };
</script>

<style scoped lang="scss">
  .spinner {
    margin: auto;
  }
  .background {
    @include background;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/paymentHistory/index.vue